import * as React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PPIRevenueFormComponent from './form-component';
import * as actions from '../../../../actions';
import PPIRevenueService from '../../../../service/sfp/ppi-revenue-service';

class RevenueFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: undefined, 
			submitting: false,
			name: ""
		};
	}

	componentDidMount() {
		if (this.props.revenue) this.setState({name: this.props.revenue.name})
	}

	render() {
		return (
			<PPIRevenueFormComponent
				name					= {this.state.name}
				delete				= {this.props.delete}
				onNameChange	= {(e) => {e.constructor === String ? this.setState({name: e}):this.setState({name: e.target.value})}}
				revenue				= {this.props.revenue}
				onSubmit      = {this._handleSubmit}
				submitting    = {this.state.submitting}
			/>
		)
	}

	_handleSubmit = (/** @type {React.SyntheticEvent<Element>} */ event) => {
		event.preventDefault();
		event.persist()
		this.setState({ submitting: true })

		const ppi_revenue = {
			name: event.target.name.value,
			ppi: this.props.ppi.id
		}

		if (this.props.delete) {
			PPIRevenueService.deletePPIRevenue(this.props.revenue)
				.then(this._resolveDeleteRevenue.bind(this, event), this._rejectDeleteRevenue)
		} else if (this.props.revenue) {
			PPIRevenueService.updatePPIRevenue(this.props.revenue.id, ppi_revenue)
				.then(this._resolveUpdateRevenue.bind(this, event), this._rejectUpdateRevenue)
		} else {
			PPIRevenueService.createPPIRevenue(ppi_revenue)
				.then(this._resolveCreateRevenue.bind(this, event), this._rejectCreateRevenue)
		}
	}

	_rejectCreateRevenue = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveCreateRevenue = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onCreated(response)
		})
	}

	_rejectUpdateRevenue = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveUpdateRevenue = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onUpdated(response)
		})
	}

	_rejectDeleteRevenue = (error) => {
		this.props.actions.throwError(error)
		this.setState({error, submitting: false})
	}

	_resolveDeleteRevenue = (
	/** @type {React.SyntheticEvent<Element>} */ event,
	/** @type {Object} */               response) => {
		event.target.reset()
		this.setState({ submitting: false }, () => {
			this.props.onDeleted(response)
		})
	}



}

const mapDispatchToProps = dispatch => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(null, mapDispatchToProps)(RevenueFormContainer);



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/revenues/form-container.js